import { z } from 'zod'
import { PrepareReceiveMessageEvents, PrepareSendMessageEvents } from './events';
import { Pathname, paths_no_params, paths_practice_crn_client_crn, paths_practice_crn_client_crn_identifier } from './paths';

const ReceiveNavigatePayloadSchema = z.union([
    z.object({
        pathName: z.enum(
            Object.keys(paths_practice_crn_client_crn) as [Pathname, ...Pathname[]]
        ),
        practiceCrn: z.string(),
        clientCrn: z.string(),
    }),
    z.object({
        pathName: z.enum(
            Object.keys(paths_practice_crn_client_crn_identifier) as [Pathname, ...Pathname[]]
        ),
        practiceCrn: z.string(),
        clientCrn: z.string(),
        identifier: z.string(),
    }),
    z.object({
        pathName: z.enum(
            Object.keys(paths_no_params) as [Pathname, ...Pathname[]]
        ),
    }),
])

export const ReceiveIfameMessageEventSchema = z.discriminatedUnion("action", [
    z.object({
        action: z.literal(PrepareReceiveMessageEvents.NAVIGATE),
        payload: ReceiveNavigatePayloadSchema,
    }),
    z.object({
        action: z.literal(PrepareReceiveMessageEvents.OVERLAY_CLICKED),
    }),
    /*
    z.object({
        action: z.literal(PrepareReceiveMessageEvents.PROVIDE_OFFSET),
        payload: z.object({ left: z.number(), top: z.number() }),
    }),
    z.object({
        action: z.literal(PrepareReceiveMessageEvents.PROVIDE_USER_LANGUAGE),
        payload: z.object({ language: z.string() }),
    }),
    */
]);

export type PrepareReceiveMessageEvent = (typeof PrepareReceiveMessageEvents)[keyof typeof PrepareReceiveMessageEvents];

const SendNavigatePayloadSchema = z.union([
  z.object({
    pathName: z.enum(['HOMEPAGE']),
  }),
  z.object({
    pathName: z.enum(['INBOX']),
    clientCrn: z.string(),
  }),
])

export const SendIframeMessageEventSchema = z.union([
    z.object({
        action: z.enum([
            PrepareSendMessageEvents.HIDE_OVERLAY,
            PrepareSendMessageEvents.SHOW_OVERLAY,
        ]),
    }),

    z.object({
        action: z.literal(PrepareSendMessageEvents.NAVIGATE),
        payload: SendNavigatePayloadSchema,
    }),

    z.object({
        action: z.literal(PrepareSendMessageEvents.SHOW_TOASTER),
        payload: z.object({}),
    }),

    z.object({
        action: z.literal(PrepareSendMessageEvents.RELOAD)
    }),
]);

export type SendIframeMessageEventData = z.infer<typeof SendIframeMessageEventSchema>;
